import BaseService from '@src/services/BaseService'

class QuestionnaireEmailsService extends BaseService {
    constructor() {
        super('questionnaire-emails')
    }
}

export default new QuestionnaireEmailsService()
